'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _pipeWith = require('./util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

var _entryArray = require('./entryArray');

var _entryArray2 = _interopRequireDefault(_entryArray);

var _reduce = require('./reduce');

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'reduce',
    immutable: 'reduce',
    record: function record(reducer, initialReduction) {
        return function (value) {
            return (0, _pipeWith2.default)(value, (0, _entryArray2.default)(), (0, _reduce2.default)(function (reduction, _ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    childValue = _ref2[1];

                return reducer(reduction, childValue, key, value);
            }, initialReduction));
        };
    },
    object: function object(reducer, initialReduction) {
        return function (value) {
            return Object.keys(value).reduce(function (reduction, key) {
                return reducer(reduction, value[key], key, value);
            }, initialReduction);
        };
    },
    array: function array(reducer, initialReduction) {
        return function (value) {
            return value.reduce(reducer, initialReduction);
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/reduce.js
// module id = 86
// module chunks = 35783957827783